import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useTranslation } from "react-i18next";
import KeyActionPanel, { KeyAction } from "@/shared/ui/KeyActionPanel";
import useComplexIntercomShow from "@/domains/estate/hooks/useComplexIntercomShow";
import IntercomWidget from "@/domains/estate/components/intercom/IntercomWidget";
import {
  ApartmentStatus,
  IntercomWidgetVariant,
} from "@/domains/estate/components/intercom/const.ts";
import KeyCode from "@/assets/constants/key-code";

function EstateComplexIntercomContainer() {
  const { t } = useTranslation("estate");
  const { show, level, estates, transit, status } = useComplexIntercomShow();

  if (!show) {
    return null;
  }

  const actions = new Map<KeyCode, KeyAction>([
    [
      KeyCode.ESCAPE,
      {
        label: t("estate.close"),
        keyName: "ESC",
        action: () => {},
        color: "red",
      },
    ],
  ]);

  [
    [KeyCode.Z, "Z"],
    [KeyCode.X, "X"],
    [KeyCode.C, "C"],
  ].forEach(([keyCode, keyName]: [KeyCode, string], index) => {
    if (estates[index]) {
      actions.set(keyCode, {
        label: t("estate.intercom.apartmentName", { room: estates[index].room }),
        keyName,
        action: () => {
          transit(estates[index].room);
        },
        color: "red",
      });
    }
  });

  return (
    <div className="absolute bottom-[--boundary-offset-y] left-[--boundary-offset-x]">
      <KeyActionPanel
        name="complex-intercom"
        actions={actions}
        className="fixed bottom-[--boundary-offset-y] left-[50%] -translate-x-[50%] z-[51]"
      />
      <IntercomWidget
        maxDigits={3}
        apartmentStatus={
          {
            [-1]: ApartmentStatus.NotSet,
            0: ApartmentStatus.Locked,
            1: ApartmentStatus.Unlocked,
          }[status]
        }
        onChange={() => {}}
        onSubmit={async (value: string) => {
          const roomNumber = parseInt(value, 10);
          await transit(roomNumber);
        }}
        submitDelayMs={1300}
        variant={
          {
            [EstateComplexLevel.Economy]: IntercomWidgetVariant.Simple,
            [EstateComplexLevel.Standard]: IntercomWidgetVariant.Modern,
            [EstateComplexLevel.Business]: IntercomWidgetVariant.Elite,
          }[level]
        }
      />
    </div>
  );
}

export default EstateComplexIntercomContainer;
